import React, { useMemo } from 'react';
import { Col, Form, Row, Tooltip } from 'antd';
import moment from 'moment';
import Input from '@/components/common/input';
import './index.scss';
import './personalInfo.scss';
import '../../style.scss';
import PhoneInput from '@/components/common/phoneInput';
import CustomSelect from '@/components/common/select';
import DateSelect from '@/components/common/dateSelect';
import { setFieldValue } from '@/utils/form';
import { GENDER } from '@/constant/gender';
import { useSelector } from 'react-redux';
import IconFlag, { ICON } from '@/components/common/icon/iconFlag';

const PersonalInformation = ({ values, form, ...props }) => {
  const business = useSelector((state) => state.business.activeList);

  const businessOption = useMemo(
    () => business.map((_) => ({ value: _.guid, label: _.name }), [business]),
    [],
  );

  return (
    <div className="personal-info">
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <Input
            placeholder="e.g John"
            label="First Name"
            name="first_name"
            rules={[{ required: true, message: 'Please input your first name!' }]}
          />
        </Col>
        <Col span={12}>
          <Input
            label="Last Name"
            name="last_name"
            rules={[{ required: true, message: 'Please input your last name!' }]}
            placeholder="e.g Doe"
          />
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <CustomSelect
            label="Gender"
            name="gender"
            rules={[{ required: true, message: 'Please select your gender!' }]}
            placeholder="Select from list below"
            options={GENDER}
          />
        </Col>
        <Col span={12}>
          <Form.Item name={['mobile_phone', 'code']} style={{ display: 'none' }} />
          <Form.Item name={['mobile_phone', 'country']} style={{ display: 'none' }} />
          <Form.Item
            label="Mobile Number"
            name={['mobile_phone', 'number']}
            rules={[{ required: true, message: 'Please input your mobile phone!' }]}
          >
            <PhoneInput
              value={values.mobile_phone?.number}
              countryCode={values.mobile_phone?.country || 'au'}
              separateDialCode
              onPhoneNumberChange={(validate, localNumber, info, globalNumber) => {
                setFieldValue(form, 'mobile_phone', {
                  code: `+${info.dialCode}`,
                  number: globalNumber.trim().replace(/\s/g, ''),
                  country: info.iso2,
                });
              }}
              preferredCountries={[]}
              onlyCountries={['au', 'nz']}
              placeholder="0412 345 678"
              inputClassName="ant-input"
            />
          </Form.Item>
        </Col>
      </Row>

      <Input
        label="Email"
        value={values.email_address}
        placeholder="e.g john.dow@mymail.com.au"
        editMode={false}
        name="email_address"
      />

      <Row gutter={[8, 8]}>
        <Col span={12}>
          <Form.Item label="Date of birth" name="date_of_birth">
            <DateSelect
              onChange={(value) =>
                setFieldValue(form, 'date_of_birth', moment(value).format('YYYY-MM-DD'))
              }
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={
              <div>
                Referral
                <Tooltip title="Tooltip with customize">
                  <IconFlag vector={ICON.ICONS_INFO_FILLED} className="referral-tooltip" />
                </Tooltip>
              </div>
            }
          >
            <CustomSelect
              value={values.preferred_business_guid}
              placeholder="Select from list below"
              options={businessOption}
              editMode={false}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};
export default PersonalInformation;
